// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"6607768a","239":"0dc8dcc3","977":"9daf960c"}[chunkId] + ".chunk.js";
};